import {z} from 'zod';
import {RecruitmentSchema} from '../companyDetail/schema';
import {
  MessageTypesEnum,
  ScoutChatStatusEnum,
  ScoutStatusEnum,
  UserTypesEnum,
} from './constants';

export const Company = z.object({
  id: z.number(),
  name: z.string(),
  logoURL: z.string(),
});

export const ScoutType = z.object({
  id: z.number(),
  name: z.string(),
});

export const ChatRoom = z.object({
  id: z.number(),
  lastMessage: z.string().optional(),
  lastMessageTime: z.string(),
});

export const Scout = z.object({
  id: z.number(),
  messageID: z.number(),
  title: z.string(),
  message: z.string(),
  status: ScoutStatusEnum,
  chatStatus: ScoutChatStatusEnum,
  deadline: z.string(),
  created: z.string(),
  scoutType: ScoutType,
  company: Company,
  chatRoom: ChatRoom.optional(),
  canChat: z.boolean(),
});

export const ScoutList = z.array(Scout);

export const GetScoutResponse = z.object({
  scout: Scout,
});

export const GetScoutsResponse = z.object({
  scouts: ScoutList,
  totalCount: z.number(),
  nextPage: z.number(),
});

export const ChatMessage = z.object({
  id: z.number(),
  userType: UserTypesEnum,
  userID: z.number(),
  messageType: MessageTypesEnum,
  body: z.string(),
  postedAt: z.string(),
});

export const ChatMessageList = z.array(ChatMessage).nullable();

export const GetChatMessagesResponse = z.object({
  lastReadAt: z.string(),
  chatMessages: ChatMessageList,
});

export const PostChatMessagesResponse = z.object({
  chatMessage: ChatMessage,
});

export const ScoutMessageStatusResponse = z.string();

export const GetUnreadScoutMessagesCountResponse = z.object({
  count: z.number(),
});

export const Unnotified = z.object({
  scoutID: z.number(),
  deadline: z.string(),
});

export const unnotifieds = z.array(Unnotified);

export const GetUnnotifiedResponse = z.object({
  unnotifieds,
});

export type GetUnnotifiedType = z.infer<typeof GetUnnotifiedResponse>;

// Users/me/scout-messages/notified-logs
export const PutNotifiedLogsData = z.object({
  scout_ids: z.array(z.number()),
  ignored: z.number(),
});

export const NotifiedLogSchema = z.object({
  id: z.number(),
  user_id: z.number(),
  scout_id: z.number(),
  scout_status: z.string(),
  ignored: z.boolean(),
});

export const PutNotifiedLogsResponse = z.object({
  logs: z.array(NotifiedLogSchema),
});

export const ScoutAcceptedCompanyRecruitment = RecruitmentSchema.extend({
  // 応募に間に合う日程のうち最も近い締切。随時受付のとき Backend は OpenAPI の規約上 null ではなくプロパティを省略する。
  // API クライアントが transform 付きの schema を受け付けないため、null への正規化はせず受け取る側で両方を随時受付として扱う
  applicableDeadline: z.string().nullish(),
  isEntered: z.boolean(),
});

export const ScoutAcceptedCompany = Company.extend({
  followerCount: z.number(),
  isFollowed: z.boolean(),
  recruitments: ScoutAcceptedCompanyRecruitment.array(),
});

export const GetScoutAcceptedCompanyRecruitmentsResponse = z.object({
  companies: ScoutAcceptedCompany.array(),
  nextPage: z.number(),
});
